import {Link, useOutletContext} from "react-router-dom";
import {useEffect} from "react";

function AboutPage() {
    const [setTitle, setCount] = useOutletContext<any>();

    useEffect(() => {
        setTitle('Om Ingenjörskompassen');
        setCount(null);
    }, []);

    const getLastFetchDate = () => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), 1);
    };

    const getPeriodEndDate = () => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), 0);
    };

    const getPeriodStartDate = () => {
        const endDate = getPeriodEndDate();
        return new Date(endDate.getFullYear() - 4, endDate.getMonth() + 1, 1)
    };

    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const lastFetchDate = formatDate(getLastFetchDate());
    const periodEndDate = formatDate(getPeriodEndDate());
    const periodStartDate = formatDate(getPeriodStartDate());

    return (
        <div>
            <div className="w-full bg-white py-8 xl:py-16">
                <div className="container max-w-3xl font-sweing">
                    <p className="font-body text-lg xl:text-xl text-black mb-4">
                        Upptäck Ingenjörskompassen – ditt verktyg för att utforska dina karriärmöjligheter
                        som ingenjör. Här kan du hitta nya karriärvägar och få en översikt av vad du kan
                        jobba med som ingenjör. Verktyget bygger på historiska jobbannonser och ger en
                        tydlig inblick i efterfrågan på olika yrken samt de kompetenser och egenskaper som
                        arbetsgivare ofta efterfrågar.
                    </p>

                    <h2 className="font-sweing font-medium text-black text-3xl xl:text-5xl mt-8">Ingenjörskompassens innehåll och omfattning</h2>
                    <p className="font-body text-lg xl:text-xl text-black mt-2 mb-4">
                        De yrken som presenteras i Ingenjörskompassen är indelade i 17 yrkesområden,
                        som exempelvis IT, Elektroteknik och Maskinteknik. Varje område är i sin tur uppdelat
                        i kategorier av yrken med liknande kompetenser. Välj mellan att söka efter ett
                        specifikt yrke eller en jobbtitel. Du kan också bläddra bland yrkesområden för att
                        hitta fram till ett yrke som intresserar dig.
                    </p>
                    <p className="font-body text-lg xl:text-xl text-black my-4">
                        Tjänsten omfattar yrken som ingenjörer ofta jobbar med. Utöver uttalade ingenjörsoch teknikyrken
                        ingår även yrken inom områden som naturvetenskap, ekonomi och
                        ledarskap där ingenjörer ofta arbetar.
                    </p>
                    <p className="font-body text-lg xl:text-xl text-black my-4">
                        I listningen av kompetenser som efterfrågats för ett visst yrke kan även krav från
                        arbetsgivare förekomma, som exempelvis att sökande av tjänsten behövde ha
                        svenskt medborgarskap, eller att resor förekom i tjänsten.
                    </p>
                    <p className="font-body text-lg xl:text-xl text-black my-4">
                        Innehållet i Ingenjörskompassen baseras på Arbetsförmedlingens dataset över
                        historiska jobbannonser. Arbetsförmedlingen står för textanalys av jobbannonserna
                        och Sveriges Ingenjörer tar inte ansvar för kvalitén eller eventuella felaktigheter i det
                        dataset som används.
                    </p>
                    <p className="font-body text-lg xl:text-xl text-black my-4">
                        Data över platsannonser i Platsbanken hämtades senast {lastFetchDate} och sträcker sig från {periodStartDate} till {periodEndDate}.
                    </p>

                    <h2 className="font-sweing font-medium text-black text-3xl xl:text-5xl mt-8">Hur du tolkar tabellerna</h2>
                    <p className="font-body text-lg xl:text-xl text-black mt-2 mb-4">
                        <em>Antal annonser:</em> Antalet unika annonser där yrket, kompetensen eller egenskapen
                        förekommit under senast uppmätta 12-månadersperiod. I tabellerna visas max 100
                        rader, dvs som mest listas de 100 kompetenser för ett yrke.
                    </p>
                    <p className="font-body text-lg xl:text-xl text-black my-4">
                        <em>Förändring:</em> Uträkningen baseras på procentuell förändring under den senast
                        uppmätta <span style={{ whiteSpace: 'nowrap' }}>12-månadersperioden</span> jämfört med föregående 12 månader. Pilarna indikerar om förändringen har
                        varit mer eller mindre än 10 procent. Vi beräknar endast förändring för de yrken, kompetenser
                        och egenskaper som haft minst 20 annonser under föregående period.
                    </p>

                    <h2 className="font-sweing font-medium text-black text-3xl xl:text-5xl mt-8">Kontakt</h2>
                    <p className="font-body text-lg xl:text-xl text-black mt-2 mb-4">
                        Har du frågor eller vill ha mer information om Ingenjörskompassen går det bra att
                        kontakta <Link className="underline" to="mailto:medlem@sverigesingenjorer.se">medlem@sverigesingenjorer.se</Link>.
                        Skriv gärna i ämnesraden vad frågan gäller.
                    </p>
                    <p className="font-body text-lg xl:text-xl text-black my-4">
                        Har du problem med tjänsten, kontakta oss gärna direkt på <Link className="underline" to="mailto:webmaster@sverigesingenjorer.se?subject=Ingenjörskompassen">webmaster@sverigesingenjorer.se</Link>.
                    </p>

                    <p className="font-body text-lg xl:text-xl text-black italic my-4">
                        Ingenjörskompassen baseras enbart på data från Arbetsförmedlingens platsbank,
                        och är ett verktyg bland många för att skapa sig en bild av ingenjörsyrket. Använd dig
                        gärna av flera källor när du utforskar din framtida karriär och kompetensutveckling.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default AboutPage;